import { Statistics } from "../Statistics";
import { CoinTable } from "../CoinTable";

export const Coins = () => (
    <>
        <Statistics />
        <CoinTable />
    </>
)